import { motion } from "framer-motion";
import { MapPin, Navigation } from "lucide-react";

const OFFICES = [
  {
    id: "delhi",
    city: "Delhi",
    address: "Unit 1701, 17th Floor, RG Trade Tower, Netaji Subhash Place, Pitampura, Delhi - 110034",
    embed: "https://maps.google.com/maps?q=RG%20Trade%20Tower%2C%20Netaji%20Subhash%20Place%2C%20Pitampura%2C%20Delhi%20110034&output=embed",
    directions: "https://www.google.com/maps/dir/?api=1&destination=RG+Trade+Tower,+Netaji+Subhash+Place,+Pitampura,+Delhi+110034",
  },
  {
    id: "tinsukia",
    city: "Tinsukia, Assam",
    address: "Manav Kalyan, Namghar Road, Tinsukia, Assam - 786125",
    embed: "https://maps.google.com/maps?q=Namghar%20Road%2C%20Tinsukia%2C%20Assam%20786125&output=embed",
    directions: "https://www.google.com/maps/dir/?api=1&destination=Namghar+Road,+Tinsukia,+Assam+786125",
  },
];

export const Offices = () => (
  <section id="visit" className="py-20 lg:py-32 bg-white border-y border-border scroll-mt-20">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="max-w-2xl"
      >
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-bronze">Visit us</p>
        <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-forest">
          Two offices, one promise of personal advice
        </h2>
        <p className="mt-4 text-base text-muted-foreground">
          Walk in for a face-to-face conversation about your money — in Delhi or in Tinsukia.
        </p>
      </motion.div>

      <div className="mt-12 lg:mt-16 grid grid-cols-1 lg:grid-cols-2 gap-8">
        {OFFICES.map((o, i) => (
          <motion.div
            key={o.id}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.1 }}
            data-testid={`office-card-${o.id}`}
            className="border border-border rounded-2xl overflow-hidden bg-bone"
          >
            <iframe
              title={`Map of Rajkiran Wealth ${o.city} office`}
              data-testid={`office-map-${o.id}`}
              src={o.embed}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="w-full h-64 lg:h-72 border-0"
            />
            <div className="p-6 lg:p-8 flex flex-col sm:flex-row sm:items-center gap-4 justify-between">
              <div className="flex gap-3">
                <MapPin className="h-5 w-5 mt-1 shrink-0 text-bronze" />
                <div>
                  <p className="font-serif text-xl font-medium text-forest">{o.city}</p>
                  <p className="mt-1 text-sm text-muted-foreground max-w-sm">{o.address}</p>
                </div>
              </div>
              <a
                href={o.directions}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`office-directions-${o.id}`}
                className="inline-flex shrink-0 items-center gap-2 rounded-full border border-forest px-5 py-2.5 text-sm font-semibold text-forest transition-colors hover:bg-forest hover:text-bone"
              >
                <Navigation className="h-4 w-4" />
                Get Directions
              </a>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
